module.exports = __webpack_public_path__ + "static/media/variable.fdaa8b47.jpg";